// Arabic strings for native PDF exports — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until
// decision H-10.
import type { enPdf } from './en-pdf.ts';
import type { Message } from './types.ts';

export const arPdf: { readonly [K in keyof typeof enPdf]: Message } = {
  // ------------------------------------------------------------ inside the PDF
  'pdf.page': 'صفحة {page} من {pages}',
  'pdf.noRows': 'لا توجد صفوف تطابق عوامل التصفية هذه.',
  'rpt.export.generatedAtSite': 'وقت الإنشاء (بتوقيت الموقع)',
  // ------------------------------------------------------------ report and roster screens
  'rpt.ui.format.pdf': 'PDF',
  'rpt.ui.downloadPdf': 'تنزيل PDF',
  'rpt.ui.pdfPreparing': 'جارٍ إعداد ملف PDF…',
  'rpt.ui.pdfReady': 'ملف PDF جاهز. إذا لم يبدأ التنزيل، استخدم «تنزيل» في قائمة تصديراتك.',
  'rpt.ui.pdfNotReady': 'تعذّر إعداد ملف PDF. راجع قائمة تصديراتك لمعرفة السبب.',
  'saf.ui.exportPdf': 'قائمة PDF',
};
